import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"
import { find, each, remove, pick } from "lodash"

import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"
import { PAGINATION_INITIAL_STATE } from "./constants"
import { toaster } from "components/common/Toast"

// ACTIONS
const requested = createAction("clients/requested")
const received = createAction("clients/received")
const failed = createAction("clients/failed")
const cleaned = createAction("clients/cleaned")

const requestedClient = createAction("clients/requestedClient")
const receivedClient = createAction("clients/receivedClient")
const failedClient = createAction("clients/failedClient")

const requestedCheckClientDelete = createAction("clients/requestedCheckClientDelete")
const receivedCheckClientDelete = createAction("clients/receivedCheckClientDelete")
const failedCheckClientDelete = createAction("clients/failedCheckClientDelete")

const createdClient = createAction("clients/createdClient")
const updatedClient = createAction("clients/updatedClient")
const deletedClient = createAction("clients/deletedClient")
const cleanedClient = createAction("clients/cleanedClient")

const editClientNote = createAction("clients/editClientNote")
const uploadFile = createAction("clients/uploadFile")
const recivedEmail = createAction("clients/recivedEmail")
const recivedSms = createAction("clients/recivedSms")
const recivedMessage = createAction("clients/recivedMessage")

const createdGroup = createAction("clients/createdGroup")
const updatedGroup = createAction("clients/updatedGroup")
const deletedGroup = createAction("clients/deletedGroup")

const addedGroupClients = createAction("clients/addedGroupClients")
const removedGroupClients = createAction("clients/removedGroupClients")

const deleteBulkGroups = createAction("clients/deleteBulkGroups")
const syncBulkGroupRequested = createAction("clients/syncBulkGroupRequested")
const syncBulkGroup = createAction("clients/syncBulkGroup")
const syncBulkGroupFailed = createAction("clients/syncBulkGroupFailed")

const requestedImportBulkClients = createAction("clients/requestedImportBulkClient")
const receivedImportBulkClients = createAction("clients/receivedImportBulkClients")
const failedImportBulkClients = createAction("clients/failedImportBulkClients")

const requestedUpdateExisting = createAction("clients/requestedUpdateExisting")
const receivedUpdateExisting = createAction("clients/receivedUpdateExisting")
const failedUpdateExisting = createAction("clients/failedUpdateExisting")

const requestedImportBulkClientHistory = createAction("clients/requestedImportBulkClientHistory")
const receivedImportBulkClientHistory = createAction("clients/receivedImportBulkClientHistory")
const failedImportBulkClientHistory = createAction("clients/failedImportBulkClientHistory")

const requestedEmailLogs = createAction("clients/requestedEmailLogs")
const receivedEmailLogs = createAction("clients/receivedEmailLogs")
const failedEmailLogs = createAction("clients/failedEmailLogs")

// Text Logs actions
const requestedTextLogs = createAction("clients/requestedTextLogs")
const receivedTextLogs = createAction("clients/receivedTextLogs")
const failedTextLogs = createAction("clients/failedTextLogs")

const requestedClientNotes = createAction("clients/requestedClientNotes")
const receivedClientNotes = createAction("clients/receivedClientNotes")
const failedClientNotes = createAction("clients/failedClientNotes")

const requestedSendMessage = createAction("clients/requestedSendMessage")
const receivedSendMessage = createAction("clients/receivedSendMessage")
const failedSendMessage = createAction("clients/failedSendMessage")

const requestedImportClientDetail = createAction("clients/requestedImportClientDetail")
const receivedImportClientDetail = createAction("clients/receivedImportClientDetail")
const failedImportClientDetail = createAction("clients/failedImportClientDetail")

const requestedSkipInvalid = createAction("clients/requestedSkipInvalid")
const receivedSkipInvalid = createAction("clients/receivedSkipInvalid")
const failedSkipInvalid = createAction("clients/failedSkipInvalid")

// Signed Waivers actions
const requestedSignedWaivers = createAction("clients/requestedSignedWaivers")
const receivedSignedWaivers = createAction("clients/receivedSignedWaivers")
const failedSignedWaivers = createAction("clients/failedSignedWaivers")

export const requestedEmail = createAction("client/email/requested")
export const receivedEmail = createAction("client/email/received")
export const failedEmail = createAction("client/email/failed")
// REDUCER
const initialState = {
  ...LOADING_INITIAL_STATE,
  items: [],
  metadata: {
    ...PAGINATION_INITIAL_STATE,
    groups_collection: [],
    email_templates_collection: [],
    text_templates_collection: []
  },
  client: {
    ...LOADING_INITIAL_STATE,
    notes: [],
    user: {
      id: null,
      nickname: "",
      avatar: "",
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      birthday: "",
      address_line_1: "",
      address_line_2: "",
      city: "",
      state: "",
      country: "",
      zip_code: ""
    },
    client_groups: [],
    groups: [],
    group: [],
    email_templates_collection: [],
    text_templates_collection: []
  },
  isClientDeletable: false,
  groupClients: {
    ...LOADING_INITIAL_STATE,
    added: 0,
    message: ""
  },
  importClientData: {
    ...LOADING_INITIAL_STATE,
    data: null
  },
  importClientHistoryData: {},
  importClientDetailData: {
    ...LOADING_INITIAL_STATE,
    data: null
  },
  skipInvalidData:{
    ...LOADING_INITIAL_STATE
  },
  emailLogs: {
    ...LOADING_INITIAL_STATE,
    data: [],
    metadata: {
      ...PAGINATION_INITIAL_STATE
    }
  },
  textLogs: {
    ...LOADING_INITIAL_STATE,
    data: [],
    metadata: {
      ...PAGINATION_INITIAL_STATE
    }
  },
  clientNotes: {
    ...LOADING_INITIAL_STATE,
    data: []
  },
  sendMessage: {
    ...LOADING_INITIAL_STATE,
    data: []
  },
  signedWaivers: {
    ...LOADING_INITIAL_STATE,
    data: [],
    metadata: {
      ...PAGINATION_INITIAL_STATE
    }
  }
}

const clientsReducer = createReducer(initialState, {
  [requested.type]: (state) => {
    setRequested(state)
  },
  [received.type]: (state, { payload, props }) => {
    setReceived(state)
    if (props.append) {
      state.items = [...state.items, ...payload.data]
    } else {
      state.items = payload.data
    }
    Object.assign(state.metadata, payload.metadata)
  },
  [failed.type]: (state) => {
    setFailed(state)
  },
  [cleaned.type]: () => initialState,
  [requestedClient.type]: (state) => {
    setRequested(state.client)
  },
  [receivedClient.type]: (state, action) => {
    setReceived(state.client)
    state.client = action.payload
  },
  [createdClient.type]: (state, action) => {
    setReceived(state.client)
    state.items = [action.payload, ...state.items]
    Object.assign(state.client, action.payload)
  },
  [updatedClient.type]: (state, action) => {
    setReceived(state.client)
    Object.assign(find(state.items, ["id", action.payload.id]) || {}, action.payload)
    Object.assign(state.client, action.payload)
  },
  [syncBulkGroupRequested.type]: (state) => {
    setRequested(state.groupClients)
  },
  [syncBulkGroupFailed.type]: (state) => {
    setFailed(state.groupClients)
  },
  [syncBulkGroup.type]: (state, action) => {
    setReceived(state.groupClients)
    Object.assign(state.groupClients, action.payload)
    if (action.payload?.status === "success") {
      toaster.success({
        title: "Groups",
        text: action.payload.message
      })
    } else {
      toaster.error({
        title: "Groups",
        text: action.payload.message
      })
    }
  },
  [deletedClient.type]: (state, action) => {
    setReceived(state.client)
    remove(state.items, ["id", action.payload.id])
  },
  [receivedCheckClientDelete.type]: (state, action) => {
    state.isClientDeletable = action.payload.is_deletable
    state.loading = false
    state.failed = false
  },
  [failedCheckClientDelete.type]: (state) => {
    state.loading = false
    state.failed = true
  },
  [requestedCheckClientDelete.type]: (state) => {
    state.loading = true
    state.failed = false
  },
  [failedClient.type]: (state) => {
    setFailed(state.client)
  },
  [recivedEmail.type]: (state) => {
    setReceived(state.client)
  },
  [recivedSms.type]: (state) => {
    setReceived(state.client)
  },
  [recivedMessage.type]: (state) => {
    setReceived(state.client)
  },
  [cleanedClient.type]: (state) => {
    state.client = initialState.client
  },
  [editClientNote.type]: (state, { payload: note }) => {
    state.client.notes = state.client.notes.map((currentNote) => {
      if (currentNote.id === note.id) {
        return { ...currentNote, isEdit: true }
      }
      return currentNote
    })
  },
  [createdGroup.type]: (state, { payload }) => {
    setReceived(state.client)
    state.metadata.groups_collection.push(pick(payload, ["id", "name", "color"]))
  },
  [updatedGroup.type]: (state, { payload }) => {
    setReceived(state.client)
    Object.assign(find(state.metadata.groups_collection, ["id", payload.id]) || {}, payload)
    each(
      state.items,
      (client) =>
        client.client_groups.length &&
        Object.assign(find(client.client_groups, ["group_id", payload.id]) || {}, pick(payload, ["name", "color"]))
    )
  },
  [deletedGroup.type]: (state, { payload }) => {
    setReceived(state.client)
    remove(state.metadata.groups_collection, ["id", payload.id])
    each(state.items, (client) => client.client_groups.length && remove(client.client_groups, ["group_id", payload.id]))
    if (payload?.message) {
      toaster.success(payload.message)
    }
  },
  [addedGroupClients.type]: (state, { payload }) => {
    setReceived(state)
    each(payload.data, ({ id, client_groups }) => Object.assign(find(state.items, ["id", id]) || {}, { client_groups }))
  },
  [removedGroupClients.type]: (state, { payload }) => {
    setReceived(state)
    each(payload.data, ({ id, client_groups }) => Object.assign(find(state.items, ["id", id]) || {}, { client_groups }))
  },
  [deleteBulkGroups.type]: (state, { payload }) => {
    setReceived(state)
    each(payload.data, ({ id, client_groups }) => Object.assign(find(state.items, ["id", id]) || {}, { client_groups }))
  },
  [requestedImportBulkClients.type]: (state) => {
    setRequested(state)
    state.importClientData.data = {}
  },
  [receivedImportBulkClients.type]: (state, action) => {
    setReceived(state)
    state.importClientData.data = action?.payload?.data
  },
  [failedImportBulkClients.type]: (state, action) => {
    setFailed(state)
    state.importClientData.data = action?.payload?.data
  },
  [requestedUpdateExisting.type]: (state) => {
    setRequested(state.importClientData)
    state.importClientData.data = {}
  },
  [receivedUpdateExisting.type]: (state, action) => {
    setReceived(state.importClientData)
    state.importClientData.data = action?.payload
  },
  [failedUpdateExisting.type]: (state, action) => {
    setFailed(state.importClientData)
    state.importClientData.data = {}

    // Update failed_records with client_data from response
    const clientData = action?.payload?.data?.client_data
    if (clientData && state.importClientDetailData?.data?.result?.failed_records) {
      Object.keys(clientData).forEach((rowKey) => {
        if (state.importClientDetailData.data.result.failed_records[rowKey]) {
          state.importClientDetailData.data.result.failed_records[rowKey] = clientData[rowKey]
        }
      })
    }
  },
  [requestedImportBulkClientHistory.type]: (state) => {
    setRequested(state)
    state.importClientHistoryData = {}
  },
  [receivedImportBulkClientHistory.type]: (state, action) => {
    setReceived(state)
    state.importClientHistoryData = action?.payload
  },
  [failedImportBulkClientHistory.type]: (state) => {
    setFailed(state)
    state.importClientHistoryData = {}
  },
  [requestedEmailLogs.type]: (state) => {
    setRequested(state.emailLogs)
  },
  [receivedEmailLogs.type]: (state, { payload, props }) => {
    setReceived(state.emailLogs)
    state.emailLogs.data = props.append ? [...state.emailLogs.data, ...payload.data] : payload.data
    state.emailLogs.metadata = payload.metadata
  },
  [failedEmailLogs.type]: (state) => {
    setFailed(state.emailLogs)
  },
  // Text Logs
  [requestedTextLogs.type]: (state) => {
    setRequested(state.textLogs)
  },
  [receivedTextLogs.type]: (state, { payload, props }) => {
    setReceived(state.textLogs)
    state.textLogs.data = props.append ? [...state.textLogs.data, ...payload.data] : payload.data
    state.textLogs.metadata = payload.metadata
  },
  [failedTextLogs.type]: (state) => {
    setFailed(state.textLogs)
  },
  [requestedClientNotes.type]: (state) => {
    setRequested(state.clientNotes)
  },
  [receivedClientNotes.type]: (state, { payload }) => {
    setReceived(state.clientNotes)
    state.clientNotes.data = payload?.data || []
    if (payload?.message) {
      toaster.success({
        text: payload.message
      })
    }
  },
  [failedClientNotes.type]: (state) => {
    setFailed(state.clientNotes)
  },
  [requestedSendMessage.type]: (state) => {
    setRequested(state.sendMessage)
  },
  [receivedSendMessage.type]: (state, { payload }) => {
    setReceived(state.sendMessage)
    state.sendMessage.data = payload.data
  },
  [failedSendMessage.type]: (state) => {
    setFailed(state.sendMessage)
  },
  [requestedSignedWaivers.type]: (state) => {
    setRequested(state.signedWaivers)
  },
  [receivedSignedWaivers.type]: (state, { payload, props }) => {
    setReceived(state.signedWaivers)
    state.signedWaivers.data = props.append ? [...state.signedWaivers.data, ...payload.data] : payload.data
    state.signedWaivers.metadata = payload.metadata
  },
  [failedSignedWaivers.type]: (state) => {
    setFailed(state.signedWaivers)
  },
  [requestedEmail]: (state) => setRequested(state),
  [receivedEmail]: (state, action) => {
    setReceived(state)
    state.list = action.payload
  },
  [failedEmail]: (state) => setFailed(state),
  [requestedImportClientDetail.type]: (state) => {
    setRequested(state.importClientDetailData)
  },
  [receivedImportClientDetail.type]: (state, action) => {
    setReceived(state.importClientDetailData)
    state.importClientDetailData.data = action?.payload
  },
  [failedImportClientDetail.type]: (state) => {
    setFailed(state.importClientDetailData)
    state.importClientDetailData.data = null
  },
  [requestedSkipInvalid.type]: (state) => {
    setRequested(state.skipInvalidData)
  },
  [receivedSkipInvalid.type]: (state) => {
    setReceived(state.skipInvalidData)
  },
  [failedSkipInvalid.type]: (state) => {
    setFailed(state.skipInvalidData)
  }
})

export const createEmail = (data) => (dispatch) => {
  return dispatch(
    api({
      url: "/user/send_invitation_email",
      data,
      method: "post",
      onStart: requestedEmail.type,
      onSuccess: receivedEmail.type,
      onError: failedEmail.type
    })
  )
}
export default clientsReducer

const getItems = (url, nextPage, params, dispatch, getState, append = false) => {
  // Extract pagination and other params
  const { q: queryParams = {}, page: _page, per_page: _per_page, ...otherParams } = params

  // Set up pagination with defaults
  const page = nextPage || _page || 1
  const perPage = _per_page || 10

  // Create base params with pagination
  const baseParams = {
    page,
    per_page: perPage
  }

  // Combine all query parameters under q[]
  const qParams = {}
  for (const [key, value] of Object.entries({ ...queryParams, ...otherParams })) {
    if (value !== undefined && value !== null) {
      qParams[`q[${key}]`] = value
    }
  }

  // Create final params object
  const finalParams = {
    ...baseParams,
    ...qParams
  }

  return dispatch(
    api({
      url,
      onStart: requested.type,
      onSuccess: received.type,
      onError: failed.type,
      params: finalParams,
      props: { append }
    })
  )
}

export const getGuideClients =
  (nextPage, params, append = false) =>
  (dispatch, getState) =>
    getItems("/guide/clients", nextPage, params, dispatch, getState, append)

export const getGuideClientIds = (params) => (dispatch) => dispatch(api({ url: "/guide/clients", params }))

export const getGuideClient = (id) => (dispatch, getState) => {
  const state = getState()
  const client = find(state.clients.items, ["id", +id])
  if (client) {
    dispatch(receivedClient(client))
    return new Promise((resolve) => resolve(client))
  }
  return dispatch(
    api({
      url: `/guide/clients/${id}`,
      onStart: requestedClient.type,
      onSuccess: receivedClient.type,
      onError: failedClient.type
    })
  )
}

export const getClientGuideClients = (id, nextPage, params) => (dispatch, getState) =>
  getItems(`/client/guides/${id}/clients`, nextPage, params, dispatch, getState)

export const createClient = (data) =>
  api({
    url: "/guide/clients",
    method: "post",
    onStart: requestedClient.type,
    onSuccess: createdClient.type,
    onError: failedClient.type,
    data,
    props: { showToast: false }
  })

export const updateClient = (id, data) =>
  api({
    url: `/guide/clients/${id}`,
    method: "put",
    data: data,
    onStart: requestedClient.type,
    onSuccess: updatedClient.type,
    onError: failedClient.type,
    props: { showToast: false }
  })

export const saveClient = (id, data) => (id ? updateClient(id, data) : createClient(data))

export const deleteClient = (id) =>
  api({
    url: `/guide/clients/${id}`,
    method: "delete",
    onStart: requestedClient.type,
    onSuccess: deletedClient.type,
    onError: failedClient.type
  })

export const CheckClientDelete = (id) =>
  api({
    url: `/guide/clients/${id}/check_deletable`,
    method: "get",
    onStart: requestedCheckClientDelete.type,
    onSuccess: receivedCheckClientDelete.type,
    onError: failedCheckClientDelete.type
  })

export const uploadCSVFile = (data) =>
  api({
    url: "/guide/client_imports",
    method: "post",
    onSuccess: uploadFile.type,
    data
  })

export const sendEmail = (data) =>
  api({
    url: "/guide/clients/send_email",
    method: "post",
    onStart: requestedSendMessage.type,
    onSuccess: receivedSendMessage.type,
    onError: failedSendMessage.type,
    data
  })
export const sendSms = (data) =>
  api({
    url: "/guide/clients/send_sms",
    method: "post",
    onStart: requestedSendMessage.type,
    onSuccess: receivedSendMessage.type,
    onError: failedSendMessage.type,
    data
  })

export const sendMessage = (data) =>
  api({
    url: "/guide/clients/send_message",
    method: "post",
    onStart: requestedSendMessage.type,
    onSuccess: receivedSendMessage.type,
    onError: failedSendMessage.type,
    data
  })

export const createGroup = (data) =>
  api({
    url: "/guide/groups",
    method: "post",
    onStart: requestedClient.type,
    onSuccess: createdGroup.type,
    onError: failedClient.type,
    data
  })

export const updateGroup = (id, data) =>
  api({
    url: `/guide/groups/${id}`,
    method: "put",
    data: data,
    onStart: requestedClient.type,
    onSuccess: updatedGroup.type,
    onError: failedClient.type
  })

export const removeGroup = (id) =>
  api({
    url: `/guide/groups/${id}`,
    method: "delete",
    onStart: requestedClient.type,
    onSuccess: deletedGroup.type,
    onError: failedClient.type
  })

export const addGroupClients = (id, data) =>
  api({
    url: `/guide/groups/${id}/add_clients`,
    method: "put",
    data: data,
    onStart: requested.type,
    onSuccess: addedGroupClients.type,
    onError: failed.type
  })

export const removeGroupClients = (id, data) =>
  api({
    url: `/guide/groups/${id}/remove_clients`,
    method: "put",
    data: data,
    onStart: requested.type,
    onSuccess: removedGroupClients.type,
    onError: failed.type
  })

export const cleanClients = () => (dispatch) => dispatch(cleaned())

export const SyncBulkGroup = (data) =>
  api({
    url: "/guide/clients/sync_bulk_groups",
    method: "post",
    data: data,
    onStart: syncBulkGroupRequested.type,
    onSuccess: syncBulkGroup.type,
    onError: syncBulkGroupFailed.type
  })

export const getEmailLogs = (id, append = false, params = {}) =>
  api({
    url: `/guide/clients/${id}/email_logs`,
    method: "get",
    onStart: requestedEmailLogs.type,
    onSuccess: receivedEmailLogs.type,
    onError: failedEmailLogs.type,
    params,
    props: { append }
  })

export const getTextLogs = (id, params = {}, append = false) =>
  api({
    url: `/guide/clients/${id}/texts`,
    method: "get",
    onStart: requestedTextLogs.type,
    onSuccess: receivedTextLogs.type,
    onError: failedTextLogs.type,
    params,
    props: { append }
  })

export const getClientNotes = (params = {}) =>
  api({
    url: "/guide/notes",
    method: "get",
    onStart: requestedClientNotes.type,
    onSuccess: receivedClientNotes.type,
    onError: failedClientNotes.type,
    params
  })

export const addClientNote = (data) =>
  api({
    url: "/guide/notes",
    method: "post",
    onStart: requestedClientNotes.type,
    onSuccess: receivedClientNotes.type,
    onError: failedClientNotes.type,
    data
  })

export const updateClientNote = (id, data) =>
  api({
    url: `/guide/notes/${id}`,
    method: "put",
    onStart: requestedClientNotes.type,
    onSuccess: receivedClientNotes.type,
    onError: failedClientNotes.type,
    data
  })

export const deleteClientNote = (id, params = {}) =>
  api({
    url: `/guide/notes/${id}`,
    method: "delete",
    onStart: requestedClientNotes.type,
    onSuccess: receivedClientNotes.type,
    onError: failedClientNotes.type,
    params
  })

export const cleanClient = () => (dispatch) => {
  dispatch(cleanedClient())
  return Promise.resolve()
}

export const editClientNoteTrigger = (note) => (dispatch) => dispatch(editClientNote(note))

export const importBulkClient = (data) => (dispatch) => {
  return dispatch(
    api({
      url: "/guide/client_imports",
      method: "post",
      data,
      onStart: requestedImportBulkClients.type,
      onSuccess: receivedImportBulkClients.type,
      onError: failedImportBulkClients.type
    })
  )
}

export const updateExisting = (data, id) => (dispatch) => {
  return dispatch(
    api({
      url: `/guide/client_imports/${id}`,
      method: "put",
      data,
      onStart: requestedUpdateExisting.type,
      onSuccess: receivedUpdateExisting.type,
      onError: failedUpdateExisting.type
    })
  )
}

export const importClientHistory =
  (params = {}) =>
  (dispatch) => {
    const { page = 1, pageSize = 10, search, status, start_date, end_date, order_by, order_direction } = params

    // Build query parameters
    const queryParams = new URLSearchParams({
      per_page: pageSize,
      page
    })

    // Add optional parameters if they exist
    if (search) queryParams.append("search", search)
    if (status) queryParams.append("status", status)
    if (start_date) queryParams.append("start_date", start_date)
    if (end_date) queryParams.append("end_date", end_date)
    if (order_by) queryParams.append("order_by", order_by)
    if (order_direction) queryParams.append("order_direction", order_direction)

    return dispatch(
      api({
        url: `/guide/client_imports?${queryParams.toString()}`,
        method: "get",
        onStart: requestedImportBulkClientHistory.type,
        onSuccess: receivedImportBulkClientHistory.type,
        onError: failedImportBulkClientHistory.type
      })
    )
  }

export const getImportClientDetail = (id) => (dispatch) => {
  return dispatch(
    api({
      url: `/guide/client_imports/${id}`,
      method: "get",
      onStart: requestedImportClientDetail.type,
      onSuccess: receivedImportClientDetail.type,
      onError: failedImportClientDetail.type
    })
  )
}

export const skipInvalidData = (id) => (dispatch) => {
  return dispatch(
    api({
      url: `/guide/client_imports/${id}/skip_invalid_data`,
      method: "put",
      onStart: requestedSkipInvalid.type,
      onSuccess: receivedSkipInvalid.type,
      onError: failedSkipInvalid.type
    })
  )
}

export const getSignedWaivers = (clientId, isAppend = false, params = {}) => (dispatch) => {
  return dispatch(
    api({
      url: `/guide/clients/${clientId}/signed_waivers`,
      method: "get",
      params,
      onStart: requestedSignedWaivers.type,
      onSuccess: receivedSignedWaivers.type,
      onError: failedSignedWaivers.type,
      props: { append: isAppend }
    })
  )
}
